import * as React from 'react';
import { useQuery, useMutation } from '@apollo/react-hooks';

import GiftLoader from 'crehana-ui/Loader';
import track from 'Utils/crehanaTracking';
import { COURSE_DETAIL_UPSELL_TRACKS } from './tracks';

import UpsellingBody from './components/UpsellingBody';

import GET_UPSELL_QUERY from './graphql/GetUpsellPromo.graphql';
import CREATE_CUSTOM_BUNDLE_UPSELL_MUTATION from './graphql/createCustomBundleUpsell.graphql';
import { SmallUpSellingProps, courseType } from './types';

const SmallUpselling = ({
  courseId,
  countryPrefix,
  parentComponent,
}: SmallUpSellingProps) => {
  const [navigationVisibility, setNavigationVisibility] = React.useState(false);
  const [
    modelNameUsedInRecommendations,
    setModelNameUsedInRecommendations,
  ] = React.useState(null);
  const [promoCourses, setPromoCourses] = React.useState<courseType[] | []>([]);
  const [currentCourse, setCurrentCourse] = React.useState<courseType | null>(
    null,
  );
  const [promoCourseCurrentIndex, setPromoCourseCurrentIndex] = React.useState(
    0,
  );
  const [createCustomBundle] = useMutation(
    CREATE_CUSTOM_BUNDLE_UPSELL_MUTATION,
  );
  const { data, loading, error } = useQuery(GET_UPSELL_QUERY, {
    variables: {
      itemId: courseId,
      nItems: 3,
    },
    onCompleted({ upsell }) {
      const courses = upsell?.courses?.courses;
      const modelName = upsell?.courses?.modelName;

      if (courses) {
        setModelNameUsedInRecommendations(modelName);
        setCurrentCourse(courses[0]);
        if (courses.length >= 2) {
          setPromoCourses(courses.slice(1));
        }
        if (courses.length > 2) {
          setNavigationVisibility(true);
        }
      }
    },
  });

  const getPrevCoursesBundle = () => {
    track(track.TYPES.MIXPANEL, COURSE_DETAIL_UPSELL_TRACKS.SWITCH_PROMO, {
      direction: 'backwards',
    });
    if (promoCourseCurrentIndex === 0) {
      setPromoCourseCurrentIndex(promoCourses.length - 1);
    } else {
      setPromoCourseCurrentIndex(promoCourseCurrentIndex - 1);
    }
  };

  const getNextCoursesBundle = () => {
    track(track.TYPES.MIXPANEL, COURSE_DETAIL_UPSELL_TRACKS.SWITCH_PROMO, {
      direction: 'forward',
    });
    if (promoCourseCurrentIndex === promoCourses.length - 1) {
      setPromoCourseCurrentIndex(0);
    } else {
      setPromoCourseCurrentIndex(promoCourseCurrentIndex + 1);
    }
  };

  if (loading || error) {
    return (
      <div className="p-24">
        <div className="flex items-center justify-center w-full">
          <GiftLoader />
        </div>
      </div>
    );
  }

  if (currentCourse === null || !data.upsell?.courses) return <span />;

  const { prices, sessionHash } = data.upsell?.courses;

  return (
    <UpsellingBody
      courses={[currentCourse, promoCourses[promoCourseCurrentIndex]]}
      prices={prices}
      sessionHash={sessionHash}
      createCustomBundle={createCustomBundle}
      parentComponent={parentComponent}
      countryPrefix={countryPrefix}
      getNextCoursesBundle={getNextCoursesBundle}
      getPrevCoursesBundle={getPrevCoursesBundle}
      navigationVisibility={navigationVisibility}
      upsellCoursePosition={promoCourseCurrentIndex + 1}
      fullRecommendedCoursesArray={promoCourses}
      currentCourse={currentCourse}
      modelNameUsedInRecommendations={modelNameUsedInRecommendations}
    />
  );
};

export default SmallUpselling;
